module.exports = __webpack_public_path__ + "img/shouchi@2x.343b41f9.png";